import React from 'react';
import { Route, Routes,  } from 'react-router-dom';
import ComparisonSlidersSection from '../../components/ComparisonSlidersSection';
import { MainGarmentPage } from '../../components/MainGarmentPage';
import GarmentContextProvider from '../../Context/GarmentContext/GarmentContext';

function GarmentPage() {
  return (
    <GarmentContextProvider>
      <Routes>
        <Route path='measuresbreakdown' element={<ComparisonSlidersSection />} />
        <Route index  element={<MainGarmentPage />} />
      </Routes>
    </GarmentContextProvider>
  );
}

export default GarmentPage;
